var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgResearch16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7062 6.50271C12.7345 9.8163 10.0713 12.5255 6.75774 12.5538C3.44415 12.5821 0.734984 9.91892 0.706645 6.60533C0.678306 3.29175 3.34153 0.582579 6.65511 0.55424C9.9687 0.525901 12.6779 3.18912 12.7062 6.50271ZM10.7063 6.51981C10.7252 8.72887 8.94969 10.535 6.74063 10.5539C4.53158 10.5728 2.72546 8.79729 2.70657 6.58823C2.68768 4.37917 4.46316 2.57306 6.67222 2.55417C8.88128 2.53527 10.6874 4.31075 10.7063 6.51981Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2929 15.7071L9.29289 10.7071L10.7071 9.29289L15.7071 14.2929L14.2929 15.7071Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4652 7.37225L9.71436 6.62183L7.4652 5.8714L6.71436 3.62011L5.96353 5.8714L3.71436 6.62183L5.96353 7.37225L6.71436 9.62011L7.4652 7.37225Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearch16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;